import { UpdateIcon } from '@radix-ui/react-icons';

export default function CgTinyBlockLoader() {
  return (
    <div className="absolute z-10 inset-0 backdrop-blur-[3px] bg-white/30 flex items-center justify-center">
      <UpdateIcon className="w-8 h-8 animate-spin text-primaryColor" />
    </div>
  );
}
